module.exports = __webpack_public_path__ + "img/forge-big.bd28d26b.png";